export const mint = "#dfe9db";
export const mintDark = "#8fa595";
export const blue = "#d9e4e9";
export const blueDark = "#8fa1a5";
export const bluePop = "#0078ef";
export const brown = "#e9e2d9";
export const brownDark = "#a59c8f";
export const grey = "#f3f3f3";
export const greyDark = "#a8a8a8";
